import { BRAND_CONFIG } from "../../brand/config";

const blue = '#09152e';
const yellowOrange = BRAND_CONFIG.colors.primary;
const FireBrick = '#B22222';
const white = "#FFF";
const yellow = "#f7cd47";
const darkBlue = "#1f2b5b";
const lightYellowOrange = '#eca644';
const lightGray = '#E6E6E6';
const black ='#000000';

export { blue, yellowOrange, FireBrick, black, white, yellow, darkBlue, lightYellowOrange, lightGray };